import { Typography } from '@mui/material'
import { FlexBoxProps } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { MinterAuctionContext } from '../../Contexts'
import { Property } from '../Property'

const MintedProperty: React.FC<FlexBoxProps> = (props) => {
  const { auction } = useContext(MinterAuctionContext)
  const minted = auction?.isMinted()
  return (
    <Property title="Minted" value={minted} {...props}>
      <Typography variant="caption">{minted === undefined ? '' : minted ? 'Yes' : 'No'}</Typography>
    </Property>
  )
}

export default MintedProperty
